import DapDSSwitch from './switch.component'

export * from './switch.component'
export default DapDSSwitch

DapDSSwitch.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-switch': DapDSSwitch
  }
}
